import { useSelectionManager } from "../../SelectionManager"
import { useMediaLibrary } from "../components/MediaLibraryContext"

export function useSelectedMedia() {
  const { media } = useMediaLibrary()
  const selectionManager = useSelectionManager()

  // TODO: [PBD-1029] Handle when select all is selected
  // The challenge is that 'media' doesn't necessarily mean All
  // SidepaneImage only shows last 4 assets - w/ selectAll, that
  // means changing the images when we scroll down a load more items

  return media.filter(({ id }) => selectionManager.isSelected(id))
}
